module.exports = __webpack_public_path__ + "img/stars.a991630.png";